import InsightsInsightLandingHeader from './InsightsInsightLandingHeader';

export { type InsightsInsightLandingHeaderProps } from './InsightsInsightLandingHeader';
export default InsightsInsightLandingHeader;
